var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.classes,style:(_vm.styles)})
}
var staticRenderFns = []

export { render, staticRenderFns }